export default {
  messageColor: Styles.color.validated,
  messageHeadingFontFamily: Styles.fontFamily.body,
  messageHeadingFontWeight: Styles.fontWeight.heavy,
  messageHeadingTextTransform: 'uppercase',
};
